export const tokensZIndex = {
    zIndex: {
        overlay: '299',
        partial: '400'
    }
};

//# sourceMappingURL=tokensZIndex.js.map